import { Box, CircularProgress, Modal } from '@mui/material'
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '../TextField/TextField';
import { useForm } from "react-hook-form"
import { createClient, editClient } from '../../services/CommonService';

const CreateEditClientModal = ({ open, setOpen, isEdit, dataToEdit, refreshDataHandler }) => {
  const { register, handleSubmit, setValue, clearErrors, formState: { errors }, } = useForm();
  const [ loading , setLoading ] = useState(false);

  useEffect(() => {
    if( isEdit ){
        setValue("clientName" , dataToEdit.clinic_name );
    }
  }, [ isEdit, dataToEdit, setValue ]);

  const handleClose = () => {
    setOpen(false);
    setValue("clientName" , "");
    clearErrors(null);
  };

  const onSubmit = (data) => {
    if(isEdit){
        setLoading(true);
        editClient(data, dataToEdit).then( res => {
            setLoading(false);
            refreshDataHandler();
            handleClose();
        });
    }else{
        setLoading(true);
        createClient(data).then( res => {
            setLoading(false);
            refreshDataHandler();
            handleClose();
        });
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "30%",
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    outline: "none",
    borderRadius: "20px"
  };

  return (
    <Modal
     open={open}
     onClose={handleClose}
     aria-labelledby="modal-modal-title"
     aria-describedby="modal-modal-description"
    >
        <Box sx={style}>
            <div className='flex flex-col rounded-tl-[20px] rounded-tr-[20px]'>
                <div className='flex justify-between items-center bg-[#EFF4FF] px-[2rem] py-[1.5rem] rounded-tl-[20px] rounded-tr-[20px]'>
                    <div className='text-[1.1rem] font-medium'>{ isEdit ? "Edit" : "Create New"} Client</div>
                    <div className='cursor-pointer' onClick={handleClose}><CloseIcon /></div>
                </div>
                <form className='flex flex-col pt-[2rem]' onSubmit={handleSubmit(onSubmit)}>
                    <div className='px-[2rem]'>
                        <TextField
                            errorClassName="text-[red]"
                            labelName={"Client Name"}
                            labelClassName="text-[#415280] text-[1rem] font-normal"
                            inputClassName="w-full focus:outline-none border border-1 rounded-md px-[10px] py-[10px] mt-[0.5rem]"
                            error={errors.clientName}
                            placeholder="add client name here..."
                            register={register("clientName", {
                            required: true,
                            })}
                        />
                    </div>
                    <div className='flex justify-end items-center mt-[2rem] py-[1.5rem] px-[2rem] border-t-[1px]'>
                        <div className='flex gap-4'>
                            <div className='bg-[#DF0F00] text-[#fff] px-[1rem] py-[0.5rem] rounded-md font-medium cursor-pointer' onClick={handleClose}>Cancel</div>
                            <button type='submit' className='bg-[#788CFC] text-[#fff] px-[3rem] py-[0.5rem] rounded-md font-medium cursor-pointer'>Submit {" "} { loading ? <CircularProgress size={18} /> : ""}</button>
                        </div>
                    </div>
                </form>
            </div>
        </Box>
    </Modal>
  )
}

export default CreateEditClientModal
